/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Pressable } from '@components/atoms'

import { deepPurple, grey } from '@mui/material/colors'

interface PropsType {
	className?: string
	tabIndex?: number
	onTabClick?: (index: number) => void
}

export const OrderViewTab = (props: PropsType) => {
	// const showTab: boolean = props.showTab ?? false
	const tabIndex: number = props.tabIndex ?? 0

	const onTabClick = (index: number) => {
		if (props.onTabClick) {
			props.onTabClick(index)
		}
	}

	return (
		<>
			<View css={style}>
				<View className={`verticalTabView ${tabIndex === 0 ? 'selected' : ''}`}>
					<Pressable className="verticalTab" onClick={() => onTabClick(0)}>
						<Text category="c1" className="verticalTabTitle">
							간단히
						</Text>
					</Pressable>
				</View>
				<View className={`verticalTabView ${tabIndex === 1 ? 'selected' : ''}`}>
					<Pressable className="verticalTab" onClick={() => onTabClick(1)}>
						<Text category="c1" className="verticalTabTitle">
							테이블
						</Text>
					</Pressable>
				</View>
			</View>
		</>
	)
}

const style = css({
	position: 'absolute',
	zIndex: 5,
	top: '4rem',
	left: '0.3rem',

	'.verticalTabView': {
		position: 'relative',
		width: 'calc(1.5rem - 2px)',
		height: '3.3rem',
		marginBottom: '1rem',
		borderLeft: '2px solid',
		borderColor: 'rgba(255, 255, 255, 0)',

		'.verticalTab': {
			position: 'absolute',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '4rem',
			height: 'calc(1.7rem - 2px)',
			top: '0.9rem',
			left: '-1.45rem',
			transform: 'rotate(270deg)',
			overflow: 'hidden',
			borderRadius: '3px',
			border: '1px solid',
			borderColor: grey[400],
			backgroundColor: grey[100],
			color: grey[500],

			'.verticalTabTitle': {
				width: '100%',
				margin: 0,
			},
		},

		'&.selected': {
			'.verticalTab': {
				borderColor: deepPurple['A400'],
				background: deepPurple['A400'],
				color: 'white',
			},
		},
	},
})
